import { Expose } from 'class-transformer';

export class ServerSetting {
    @Expose({ name: 'setting_id' })
    settingId: number;
    key: string;
    value: any;
    @Expose({ name: 'editable_by_admin' })
    editableByAdmin?: boolean;
}
